import { render, staticRenderFns } from "./MessageBubble.vue?vue&type=template&id=ee17df86&scoped=true&"
import script from "./MessageBubble.vue?vue&type=script&lang=js&"
export * from "./MessageBubble.vue?vue&type=script&lang=js&"
import style0 from "./MessageBubble.vue?vue&type=style&index=0&id=ee17df86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee17df86",
  null
  
)

export default component.exports